<!-- eslint-disable -->

<template>
	<div class="d-flex flex-column mb-4 bg-white rounded-lg px-4">
		<!-- show Status and Time -->
		<Header :status="status" :dateTime="deadlineDate" @is_expired="flagIsExpired()" />

		<div class="pt-4">
			<div class="text-center">
				<span class="text-gotham" style="font-size: 14px"
					>{{ language == "en" ? "Door Number" : "Nomor Pintu" }} :</span
				>
				<div class="door-number text-gotham-bold">
					{{ doorNumber }}
				</div>
			</div>
		</div>

		<div class="divider my-4"></div>

		<InfoList :title="language == 'en' ? 'Rent Info' : 'Info Sewa'" :data="rentInfo" />

		<div class="divider my-4"></div>

		<Collapsible
			id="howto"
			:title="
				language == 'en' ? howToStep.title : howToStep.title_bahasa
			"
			:open="toogleHowto"
			@onClick="toogleHowto = !toogleHowto"
		>
			<HowTo :content="instruction" />
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="history"
			:title="language == 'en' ? 'Status History' : 'Riwayat Status'"
			:open="toogleHistory"
			@onClick="toogleHistory = !toogleHistory"
		>
			<History :data="logs" />
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="info"
			:title="language == 'en' ? 'PaxelBox Location Info' : 'Info Lokasi PaxelBox'"
			:open="toogleInfo"
			@onClick="toogleInfo = !toogleInfo"
		>
			<div>
				<div class="py-2 text-gotham-bold" style="font-size: 16px;">
					{{ addressMain || "-" }}
				</div>
				<div class="text-gotham text-left" style="font-size: 12px;line-height: 16px;">
					{{ addressDetail || "-" }}
				</div>
				<div class="py-2 " v-if="lat && long">
					<span
						@click="openMapLink()"
						class="text-purple text-gotham-bold text-left"
						style="font-size: 12px;line-height: 16px;color: #5e51a1;"
						>{{ language == "en" ? "See map" : "Lihat peta" }} >
					</span>
				</div>
				<div class="py-2 text-gotham text-left" style="font-size: 12px;line-height: 16px;">
					{{ addressAdditionalDetail || "-" }}
				</div>
				<div
					class="py-2 text-gotham text-left"
					style="font-size: 12px;line-height: 16px;white-space:pre-wrap"
				>
					<div>{{ language == "en" ? "Operational Hours" : "Jam Operasional" }} :</div>
					<div class="mt-2">{{ operationalHour || "-" }}</div>
				</div>
				<div class="row px-3">
					<div class="" style="height: 160px;width: 50%;">
						<img
							v-if="locker_photo"
							:src="locker_photo"
							class="image-fit"
							@click="showPhoto(locker_photo)"
							@error="imageUrlNoContent"
							alt="Locker"
						/>
					</div>
				</div>
			</div>
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="payment"
			:title="language == 'en' ? 'Payment Details' : 'Rincian Pembayaran'"
			:open="tooglePaymentDetail"
			@onClick="tooglePaymentDetail = !tooglePaymentDetail"
		>
			<InfoList :data="paymentInfo" />
		</Collapsible>

		<div class="divider my-4"></div>

		<div class="text-center mx-6">
			<button
				class="button rounded-lg py-3 text-gotham-bold"
				style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
				@click="buttonContactSupport()"
			>
				{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
				<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
			</button>
		</div>

		<template>
			<div class="divider my-4"></div>
			<div class="text-center mx-6"
				:style="{
					background: 'white',
					position: 'sticky',
					bottom: '0',
					margin: '0 -1.5rem',
					padding: '0 1.5rem',
					marginBottom: '-1.5rem',
					paddingBottom: '1.5rem',
				}"
			>
				<div class="button rounded-lg py-3 text-gotham-bold"
					style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;"
					v-if="loadingOverdueRental">
					<loadingCircle  style="height: 20px;width: 20px;"/>
				</div>
				<button
					v-else
					class="button rounded-lg py-3 text-gotham-bold"
					style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;"
					@click="clickPickUpItems()"
				>
					<span class="text-gotham-bold text-white text-16" style="cursor: pointer">
						{{ language == "en" ? "Pick Up Items" : "Ambil Barang" }}
					</span>
				</button>
			</div>
		</template>

		<!-- MODAL Pickup-->
		<b-modal v-model="showModal" title="Pickup" id="modal-center" centered hide-header hide-footer no-close-on-backdrop>
			<div class="d-flex text-gotham pickup-card-container" style="gap:12px;">
				<!-- OPEN LOCKER -->
				<div class="pickup-card" style="border: solid #5f51a1;" @click="handlePickup('open')">
					<div class="content">
						<img
							src="@/assets/icons/ic_openlocker.svg"
							alt="open_locker"
							class="align-self-center"
							style="width:36px;"
						/>
						<span class="text-gotham-bold" style="color:#5f51a1;">
							{{ language == "en" ? "Open Locker" : "Buka Loker" }}
						</span>
						<span>
							{{
								language == "en"
									? "Pick up items and continue renting"
									: "Ambil barang dan melanjutkan sewa loker."
							}}
						</span>
					</div>
					<div class="button text-gotham-bold button-card" style="background-color:#5f51a1;">
						<loadingCircle  style="height: 20px;width: 20px;" v-if="loadingGenerateQrcode"/>
						<span v-else>{{ language == "en" ? "Open Locker" : "Buka Loker" }}</span>
					</div>
				</div>
				<!-- STOP RENT -->
				<div class="pickup-card" style="border: solid #FF434F;" @click="openModalStopRent()">
					<div class="content">
						<img
							src="@/assets/icons/ic_stoprent.svg"
							alt="stop_rent"
							class="align-self-center"
							style="width:36px;"
						/>

						<span class="text-gotham-bold" style="color:#FF434F;">
							{{ language == "en" ? "Stop Rent" : "Berhenti Sewa" }}
						</span>
						<span>
							{{
								language == "en"
									? "Pick up items and end locker rent"
									: "Ambil barang sekaligus mengakhiri sewa loker."
							}}
						</span>
					</div>
					<div class="button text-gotham-bold button-card" style="background-color:#FF434F;">
						{{ language == "en" ? "Stop Rent" : "Berhenti Sewa" }}
					</div>
				</div>
			</div>
		</b-modal>

		<!-- MODAL Stop Rent -->
		<b-modal v-model="showModalStopRent" title="StopRent" id="modal-center" centered hide-header hide-footer no-close-on-backdrop>
			<img
				src="@/assets/images/button-back.svg"
				alt="back"
				class="modal-back-button"
				style="width:36px;"
				@click="handleBrowserBack"
			/>
			<div class="d-flex text-gotham pickup-card-container" style="gap:12px;">
				<!-- OPEN LOCKER -->
				<div class="pickup-card" style="border: solid #FF434F;" @click="handleStopWithoutOpenLocker">
					<div class="content">
						<img
							src="@/assets/icons/ic_cross.svg"
							alt="open_locker"
							class="align-self-center"
							style="width:36px;"
						/>
						<span class="text-gotham-bold" style="color:#FF434F;">
							{{ language == "en" ? "Without Opening Locker" : "Tanpa Buka Loker" }}
						</span>
						<span class="px-4">
							{{
								language == "en"
									? "End the rent without opening the locker"
									: "Akhiri sewa tanpa buka loker."
							}}
						</span>
					</div>
					<div class="button text-gotham-bold text-white button-card" style="background-color:#FF434F;">
						<loadingCircle  style="height: 20px;width: 20px;" v-if="loadingGenerateQrcode"/>
						<span v-else>{{ language == "en" ? "Stop Directly" : "Langsung Akhiri" }}</span>
					</div>
				</div>
				<!-- Open & Stop Rent -->
				<div class="pickup-card" style="border: solid #424143;" @click="handlePickup('stop')">
					<div class="content">
						<img
							src="@/assets/icons/ic_paxelBox.svg"
							alt="stop_rent"
							class="align-self-center"
							style="width:36px;"
						/>

						<span class="text-gotham-bold" style="color:#424143;">
							{{ language == "en" ? "Open & Stop Rent" : "Buka & Akhiri" }}
						</span>
						<span>
							{{
								language == "en"
									? "Pick up items before stopping rent"
									: "Ambil barang sebelum akhiri sewa."
							}}
						</span>
					</div>
					<div class="button text-gotham-bold text-white button-card" style="background-color:#424143;">
						{{ language == "en" ? "Open Locker First" : "Buka Loker Dulu" }}
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal v-model="showModalStopConfirm" centered cancel-disabled size="md" hide-header hide-footer no-close-on-backdrop @shown="startCountdown">
			<div class="modal-content-custom">
				<div class="text-gotham-bold text-18 px-3">
					{{ language == "en" ? "ATTENTION" : "PERHATIAN" }}
				</div>
				<div class="modal-body-custom">
					<div v-if="language == 'en'">
						You will end your rental without opening the locker door. <b>Please ensure you leave nothing behind</b>
					</div>
					<div v-else>
						Kamu akan mengakhiri sewa tanpa membuka pintu loker. <b>Pastikan tidak ada barang yang tertinggal.</b>
					</div>
				</div>
				<div class="button rounded-lg py-3 text-gotham-bold text-center "
					style="width: 100%;background-color:white;color:#FF434F;border:1px solid white;"
					v-if="loadingStopRentWithoutScanQr">
					<loadingCircle  style="height: 36px;width: 36px;"/>
				</div>
				<div class="modal-footer-custom justify-between" v-else>
						<button
							class="back-button"
							@click="closeModalStopConfirm"
						>
							{{ language == "en" ? "BACK" : "KEMBALI" }}
						</button>
						<button
							class="confirm-button"
							:disabled="countdown > 0"
							@click="handleApiStopRentWithoutScanQr"
						>
							{{ language == "en" ? "STOP RENT" : "BERHENTI SEWA" }}
							<span v-if="countdown > 0" class="countdown-text">({{ countdown }})</span>
						</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
/* eslint-disable */
import Header from "./components/Header.vue";
import InfoList from "./components/InfoList.vue";
import Collapsible from "./components/Collapsible.vue";
import History from "./components/History.vue";
import Qrcode from "./components/Qrcode.vue";
import WarningBox from "./components/WarningBox.vue";
import HowTo from "./components/HowTo.vue";
import loadingCircle from "@/views/reuse/loadingCircle.vue";
import i18n from '@/plugins/i18n';

export default {
	components: { Header, InfoList, Collapsible, History, Qrcode, WarningBox, HowTo, loadingCircle },
	props: {
		status: {
			type: String,
			default: "in-store"
		},
		order: {
			type: Object,
			default() {
				return {};
			}
		},
		boxLocationDetail: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			loadingIcon: true,
			pakpoboxAPIUrl: process.env.VUE_APP_PAKPOBOX_API,
			heraUrl: process.env.VUE_APP_HERA_LINK,
			addressMain: "",
			addressDetail: "",
			addressAdditionalDetail: "",
			mapUrl:"",
			lat: "",
			long: "",
			locker_photo: "",
			operationalHour: "",
			doorNumber: "-",
			rentDate: "",
			deadlineDate: "",
			orderNumber: "",
			size: "",
			paymentMethod: "",
			payOfAmount: "",
			paymentDetail: {},
			adminFee: {},
			donation: [],
			totalDonation: 0,
			logs: [],
			//
			toogleHowto: true,
			toogleHistory: true,
			toogleInfo: true,
			tooglePaymentDetail: true,
			showModal: false,
			qrCode: "",
			isBase64: false,
			howToStep : {
				description:"",
				description_bahasa:"",
				title:"",
				title_bahasa:"",
				value:"",
			},
			instruction:"",
			totalOverdue: 0,
			loadingOverdueRental:false,
			is_expired:false,
			loadingGenerateQrcode:false,
			loadingStopRentWithoutScanQr:false,
			showModalStopRent:false,
			settingStopRent:'disable',
			showModalStopConfirm:false,
			countdown: 3,
			countdownInterval: null,
			modalHistory: []
		};
	},
	computed: {
		rentInfo() {
			return [
				{
					label: this.language == "en" ? "Rent Start" : "Sewa Dimulai",
					key:"title",
					value: this.rentDate,
					isDate: true
				},
				{
					label: this.language == "en" ? "Rent Ends" : "Batas Akhir Sewa",
					key:"deadlineDate",
					value: this.deadlineDate,
					isDate: true,
					addBreak: true,
					info:
						this.language == "en"
							? "There are additional fees if the time limit is exceeded"
							: "Ada biaya tambahan jika melewati batas waktu"
				},
				{
					label: this.language == "en" ? "Order Number" : "Nomor Order",
					key:"orderNumber",
					value: this.orderNumber
				},
				{
					label: this.language == "en" ? "PaxelBox Size" : "Ukuran PaxelBox",
					key:"boxSize",
					value: this.size
				}
			];
		},
		paymentInfo() {
			const arr = [
				{
					label: this.language == "en" ? "Rent Fee" : "Biaya Sewa",
					value: this.formatRupiah(this.payOfAmount),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Admin Fee" : "Biaya Admin",
					value: this.formatRupiah(this.adminFee?.total_amount ?? 0),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Total Payment" : "Total Pembayaran",
					value: this.formatRupiah(
						(this.payOfAmount ?? 0) + (this.adminFee?.total_amount ?? 0) + (this.totalDonation ?? 0)
					),
					labelStyle: "font-weight:bold;font-size:14px",
					valueStyle: "font-weight:bold;font-size:16px",
					addBreak: true
				},
				{
					label: this.language == "en" ? "Payment Method" : "Metode Pembayaran",
					value: this.paymentMethod,
					addBreak: true
				}
			];

			if(this.donation){
				const donations = this.donation.map(donate => {
					return {
						label: `${donate.qty} item | ${this.language == "en" ? donate.name.en : donate.name.id}`,
						value: this.formatRupiah(donate.sub_total),
						addBreak: true
					};
				});
	
				arr.splice(1, 0, ...donations);
				return arr;
			}else{
				return arr;
			}
		},
	},
	mounted() {
		// Handle browser back button for modal navigation
		window.addEventListener('popstate', this.handleBrowserBack);
		
		if (this.order?.barcode?.qrcodeCustomerTake) {
			this.qrCode = this.order?.barcode?.qrcodeCustomerTake;
			this.isBase64 = false;
		}
		this.doorNumber = this.order?.mouth.number;
		this.rentDate = this.order?.createTime;
		var date = new Date(this.order?.overdueDatetime);
		var unixTimeStamp = Math.floor(date.getTime());
		// this.deadlineDate = this.order?.overdueTime;
		this.deadlineDate = unixTimeStamp;
		this.orderNumber = this.order?.expressNumber;
		
		this.addressMain = this.boxLocationDetail?.locker_location || "-";
		this.addressDetail = this.boxLocationDetail?.location_address || "-";
		this.lat = this.boxLocationDetail?.latitude
		this.long = this.boxLocationDetail?.longitude
		this.locker_photo = this.boxLocationDetail?.locker_photo
		this.addressAdditionalDetail = this.boxLocationDetail?.location_description_bahasa || "-";
		this.operationalHour = this?.boxLocationDetail?.operational_hour_bahasa;
		if(this.language == 'en'){
			this.addressAdditionalDetail = this.boxLocationDetail?.location_description || "-";
			this.operationalHour = this?.boxLocationDetail.operational_hour;
		}

		this.size = this.sizeDoorLabel(this.order?.mouth?.mouthType?.name)
		this.paymentMethod = this.order.paymentMethod;
		this.payOfAmount = this.order.payOfAmount;
		this.paymentDetail = this.order.payment_detail;
		this.donation = this.order.donation;
		this.totalDonation = this.order.total_donation;
		this.adminFee = this.order.admin_fee;
		this.logs = this.order.logs;
		this.howToStep = this.getPaxelBoxContentSetting("how_to_pick_up_items")

		this.instruction = this.howToStep.description_bahasa?.replaceAll("{{door_number}}", this.doorNumber);
		if(this.language == 'en'){
			this.instruction = this.howToStep.description?.replaceAll("{{door_number}}", this.doorNumber);
		}
		this.getOverdueCalculationRentals();

		this.$store
			.dispatch("getPaxelboxSettings", 'stop_rent_without_scan')
			.then(res => {
				this.settingStopRent = res.data?.value || 'disable'
			})
			.catch(error => {
				console.log(error);
			});
	},
	beforeDestroy() {
		// Clean up event listener
		window.removeEventListener('popstate', this.handleBrowserBack);
	},
	methods: {
		openMapLink() {
			this.buttonSyncOpenGmapLocation(this.lat, this.long, this.mapUrl)
		},
		contactHera(url) {
			window.location.href = url;
		},
		async clickPickUpItems(){
			this.sendCustomEventPickupItems()
			try {
				// check overdue , there's double validation using curent time or when countdown already expired
				if (Date.now() > this.deadlineDate || this.is_expired){
					// Wait for the API call to complete
					const ret = await this.getOverdueCalculationRentals();
					//check overdue price, if price higher than 0 then redirect to page payment, but if it was setting free in cms, generate new qrcode to stop then rediredt page to stop page with its behaviour (countdown stop rent)
					if(this.totalOverdue > 0 ){
						this.$router.push(this.$route.fullPath+"&status=overdue");
					}else{
						await this.generateQrcodeOverdue();
						this.handlePickup("stop")
					}
				}else{
					this.showModal = true;
					this.addToModalHistory('showModal');
				}
			} catch (err) {
				console.error("Error fetching data:", err);
				this.error = err;
			}
		},
		async handlePickup(type) {
			let query = {};

			if (type === "open") {
				if (this.loadingGenerateQrcode){return} //handle rapid click
				try {
					this.sendCustomEventOpenLocker()
					await this.generateQrcode();
					query.act = "open_locker";
					query.base64 = this.isBase64;
					if (this.qrCode) {
						if (this.isBase64) {
							localStorage.setItem('bloburl',this.qrCode)
							localStorage.setItem('isBase64',this.isBase64)
						} else {
							// query.qrCode = this.qrCode;
						}
					}
				} catch (err) {
					console.error("Error fetching data:", err);
					this.error = err;
				}
			} else {
				query = {
					...this.$route.query,
					act: "stop_count",
					status: "stop",
					qrdisplay: "data"
				};
				if(this.totalOverdue == 0 && Date.now() > this.deadlineDate){
					query.qrdisplay = "overdue"
				}
				this.sendCustomEventStopRent()
			}
			this.showModal = false;
			this.$router.push(`/order-status/action${this.objectToQuery({ obj: query })}`);
		},
		async generateQrcode() {
			if(this.loadingGenerateQrcode == false){
				let payload = { expressNumber: this.order.expressNumber };
				this.loadingGenerateQrcode = true;
				return new Promise((resolve) => {
					this.$store
						.dispatch("temporaryQrcode", payload)
						.then(res => {
							this.loadingGenerateQrcode = false;
							this.qrCode = res.data.temporaryQrcode;
							this.isBase64 = true;
							resolve(res)
						})
						.catch(error => {
							reject(error)
							this.loadingGenerateQrcode = false;
							console.log(error);
						});
				})
			}
		},
		getOverdueCalculationRentals(){
			const paramOrderId = this.$route.query.orderid;
			if(paramOrderId != undefined){
				this.loadingOverdueRental = true;
				return new Promise((resolve) => {
					this.$store.dispatch("getOverdueCalculationRentals", paramOrderId)
					.then((response) => {
						this.loadingOverdueRental = false;
						let overdue = response.data
						this.totalOverdue = overdue.total_overdue_fee
						resolve(response);
					})
					.catch((error) => {
						this.loadingOverdueRental = false;
						const message = error.response.data.message || i18n.t('something_wrong');
						this.$swal({
							icon: 'error',
							title: 'Oops...',
							text: message,
						});
						resolve(error);
					});
      	});
			}else{
				console.log("not found");
			}
		},
		async generateQrcodeOverdue() {
			let payload = { id: this.order.id, status:this.order.status };
			this.loadingOverdueRental = true;
			await this.$store
			.dispatch("overdueQrcode", payload)
			.then(res => {
					this.loadingOverdueRental = false;
					localStorage.setItem('qrOverdue',res.data?.message)
				})
				.catch(error => {
					this.loadingOverdueRental = false;
					localStorage.setItem('qrOverdue',this.order.barcode.qrcodeCustomerTake)
					console.log(error);
				});
		},
		flagIsExpired(){
			this.is_expired = true;
			this.showModal = false; /* close modal open/stop rental */
			this.getOverdueCalculationRentals()
		},
    sendCustomEventPickupItems(){
      if(this.$store.getters.getOrderDetail){
				let rentalDetail = this.$store.getters.getOrderDetail
				let startDate = this.epochToDateTimeLocalFormat(rentalDetail.createTime,true)
        let netcorePayload = this.generalEventPayloadData();
				netcorePayload.Start_Date_Rent = startDate.date
				netcorePayload.Start_Time_Rent = startDate.time
				netcorePayload.Payment_Method = rentalDetail.paymentMethod  
				this.recordEvent('Pickup_Item_PaxelBox', netcorePayload) 
      }
		},
		sendCustomEventOpenLocker(){
      if(this.$store.getters.getOrderDetail){
				//try get data from localstorage
				let storagelockerUserData = localStorage.getItem('lockerUserData');
				let frequency = 0; //total frequency locker user
				let index = -1; //index localstorage data
				let lockerUserData = [];
				if(storagelockerUserData){
					// try to parse string object
					lockerUserData = this.jsonParse(storagelockerUserData)
					if(lockerUserData){
						//find the id, and check value frequency
						index = lockerUserData.findIndex((a) => a.id === this.order.expressNumber);
						if(index >= 0){
							frequency = parseInt(lockerUserData[index].open_frequency)
						}
					}
				}
				let newFrequency = frequency+1 
				let scanDate = this.epochToDateTimeLocalFormat(Date.now(),true)
        let netcorePayload = this.generalEventPayloadData();
				netcorePayload.Open_Date_Rent = scanDate.date
				netcorePayload.Open_Time_Rent = scanDate.time
				netcorePayload.Frequency_Open = newFrequency

				if(index >=0){
					lockerUserData[index].open_frequency = newFrequency
					//save new data to localstorage
					localStorage.setItem('lockerUserData', JSON.stringify(lockerUserData));
				}else{
					let objFreq = {
						"id":this.order.expressNumber,
						"open_frequency": newFrequency
					}
					lockerUserData.push(objFreq)
					//save new data to localstorage
					localStorage.setItem('lockerUserData', JSON.stringify(lockerUserData));
				}
				this.recordEvent('Multi_Open_PaxelBox', netcorePayload)
      }
		},
		sendCustomEventStopRent(){
			if(this.$store.getters.getOrderDetail){
				let stopDate = this.epochToDateTimeLocalFormat(Date.now(),true)
        let netcorePayload = this.generalEventPayloadData()
				netcorePayload.Stop_Date_Rent = stopDate.date
				netcorePayload.Stop_Time_Rent = stopDate.time
				this.recordEvent('Stop_Rent_PaxelBox', netcorePayload)
      }
		},
		openModalStopRent(){
			if (this.settingStopRent == 'enable'){
				this.showModalStopRent = true;
				this.showModal = false;
				this.addToModalHistory('showModalStopRent');
			}else{
				this.handlePickup('stop')
			}
		},
		handleStopWithoutOpenLocker(){
			this.showModalStopConfirm = true;
			this.showModalStopRent = false;
			this.addToModalHistory('showModalStopConfirm');
		},
		startCountdown() {
			this.countdown = 3;
			this.countdownInterval = setInterval(() => {
				this.countdown--;
				if (this.countdown <= 0) {
					clearInterval(this.countdownInterval);
					this.countdownInterval = null;
				}
			}, 1000);
		},
		closeModalStopConfirm() {
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
				this.countdownInterval = null;
			}
			this.showModalStopConfirm = false;
		},
		addToModalHistory(modalName) {
			this.modalHistory.push(modalName);
			window.history.pushState({ modal: modalName }, '', window.location.href);
		},
		handleBrowserBack(event) {
			if (this.modalHistory.length > 0) {
				event.preventDefault();
				
				const currentModal = this.modalHistory.pop();
				if (currentModal === 'showModalStopConfirm' && this.modalHistory.includes('showModalStopRent')) {
					// Going back from stop confirm modal to stop rent modal
					this.closeModalStopConfirm();
					this.showModalStopRent = true;
				} else if (currentModal === 'showModalStopRent' && this.modalHistory.includes('showModal')) {
					// Going back from stop rent modal to pickup modal
					this.showModalStopRent = false;
					this.showModal = true;
				} else if (currentModal === 'showModal') {
					// Going back from pickup modal (first modal), close all modals
					this.showModal = false;
					this.showModalStopRent = false;
					this.showModalStopConfirm = false;
					this.modalHistory = [];
				}
			}else{
				this.buttonSyncBackToUA()
			}
		},
		async handleApiStopRentWithoutScanQr() {
			// Handle the stop rent confirmation
			let payload = { order_id: this.order.id };
			this.loadingStopRentWithoutScanQr = true;
			await this.$store
			.dispatch("stopRentWithoutScanQr", payload)
			.then(res => {
				// Emit event to parent component to refresh order status
				this.$router.push('order-status/action?act=stop_success');
				this.closeModalStopConfirm();
			})
			.catch(error => {
				this.loadingStopRentWithoutScanQr = false;
				const message = error.response.data.code_messages || i18n.t('something_wrong');
				this.$swal({
					icon: 'error',
					title: 'Oops...',
					text: message,
				});
			});
		},
	}
};
</script>
<style scoped>
.door-number {
	font-size: 48px;
	color: #ff434f;
}
.divider {
	height: 1rem;
	background-color: #f9f9fb;
	margin-right: -1.5rem;
	margin-left: -1.5rem;
}
.text-16 {
	font-size: 16px;
}

.pickup-card-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.pickup-card {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	flex: 1;
	min-width: 0; /* Prevent flex items from growing beyond container */
	border-radius: 8px;
	cursor: pointer;
}

.pickup-card .content {
	flex: 1;
	display: flex;
	flex-direction: column;
	text-align: center;
	padding: 16px 6px 28px 6px;
	gap: 8px;
	overflow: hidden; /* Prevent content from overflowing */
	word-wrap: break-word; /* Break long words */
}

.pickup-card .button {
	flex: 1;
	max-height: 72px;
	text-align: center;
	color: #fff;
	padding: 12px 28px;
	width: 100%; /* Ensure button takes full width */
	box-sizing: border-box; /* Include padding in width calculation */
}

/* Custom styles for modal without borders */
.modal-content-custom {
	border: none !important;
	border-radius: 0.3rem;
}

.modal-body-custom {
	padding: 1rem;
}

.modal-footer-custom {
	padding: 0.75rem;
	border-top: none !important;
	display: flex;
	justify-content: space-between;
	gap: 0.5rem;
}

.back-button {
	background: none;
	border: none;
	color: #5e51a1;
	font-weight: bold;
	cursor: pointer;
	padding: 0.5rem 1rem;
}

.confirm-button {
	background: none;
	border: none;
	color: #FF434F;
	font-weight: bold;
	cursor: pointer;
	padding: 0.5rem 1rem;
	display: flex;
	align-items: center;
	gap: 0.25rem;
}

.confirm-button:disabled {
	color: #ccc;
	cursor: not-allowed;
}

.countdown-text {
	font-size: 0.9em;
}
.button-card{
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.modal-back-button {
	position: absolute;
	top: -40px;
	left: 0;
	width: 32px;
	height: 32px;
	cursor: pointer;
	z-index: 1050;
}

</style>
